import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ItemBodyWrapper } from '@instructure/quiz-rce';
import TargetContainer from '../common/TargetContainer';
import Square from '../common/Square';
import Oval from '../common/Oval';
import Polygon from '../common/Polygon';
var getShape = function getShape(type) {
  switch (type) {
    case 'square':
      return Square;
    case 'oval':
      return Oval;
    case 'polygon':
      return Polygon;
    default:
      return Square;
  }
};

/**
 ---
category: HotSpot
---

  HotSpot Show component

  ```jsx_example
  <SettingsSwitcher locales={LOCALES}>
    <HotSpotShow
      itemBody="Which of these players is David Ferrer"
      interactionData={{
        imageUrl: 'https://i.ytimg.com/vi/LgkAebhJ7iE/maxresdefault.jpg'
      }}
      scoringData={{
        value: {
          type: 'oval',
          coordinates: [
            { x: 0.6, y: 0.13 },
            { x: 0.7, y: 0.2 }
          ]
        }
      }}
    />
  </SettingsSwitcher>
  ```
**/
var HotSpotShow = /*#__PURE__*/function (_Component) {
  function HotSpotShow() {
    var _this;
    _classCallCheck(this, HotSpotShow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HotSpotShow, [].concat(args));
    _defineProperty(_this, "prepareHotspots", function () {
      var value = _this.props.scoringData.value;
      if (Array.isArray(value)) {
        return value.map(function (hotspot) {
          return {
            coordinates: hotspot.coordinates,
            drawingType: getShape(hotspot.type)
          };
        });
      }
      return [{
        coordinates: value.coordinates,
        drawingType: getShape(value.type)
      }];
    });
    return _this;
  }
  _inherits(HotSpotShow, _Component);
  return _createClass(HotSpotShow, [{
    key: "render",
    value: function render() {
      var hotspots = this.prepareHotspots();
      return /*#__PURE__*/React.createElement(ItemBodyWrapper, {
        itemBody: this.props.itemBody
      }, /*#__PURE__*/React.createElement(TargetContainer, {
        hotspots: hotspots,
        url: this.props.interactionData.imageUrl,
        readOnly: true
      }));
    }
  }]);
}(Component);
_defineProperty(HotSpotShow, "propTypes", {
  itemBody: PropTypes.string.isRequired,
  interactionData: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired
  }).isRequired,
  scoringData: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.shape({
      type: PropTypes.oneOf(['square', 'oval', 'polygon']),
      coordinates: PropTypes.arrayOf(PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
      })).isRequired
    }), PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf(['square', 'oval', 'polygon']),
      coordinates: PropTypes.arrayOf(PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
      })).isRequired
    }))]).isRequired
  }).isRequired
});
export { HotSpotShow as default };